import { DentalChartEnum, SpeciesEnum } from "requests";
import {
  CAT_ADULT_TEETH,
  CAT_MILK_TEETH,
  DOG_ADULT_TEETH,
  DOG_MILK_TEETH,
  RABBIT_TEETH
} from "./constants";

export const getJaw = (
  species: SpeciesEnum | null,
  milkOrAdultTeeth: DentalChartEnum | null
) => {
  const jaws: {
    [species in SpeciesEnum]?: {
      [chart in DentalChartEnum]: {
        [arcade in "1" | "2" | "3" | "4"]: number[];
      };
    };
  } = {
    [SpeciesEnum.Dog]: {
      [DentalChartEnum.Deciduous]: DOG_MILK_TEETH,
      [DentalChartEnum.Adult]: DOG_ADULT_TEETH
    },
    [SpeciesEnum.Cat]: {
      [DentalChartEnum.Deciduous]: CAT_MILK_TEETH,
      [DentalChartEnum.Adult]: CAT_ADULT_TEETH
    }
  };

  return species && milkOrAdultTeeth
    ? jaws[species]?.[milkOrAdultTeeth] || RABBIT_TEETH
    : null;
};
